exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.dialog-header-text[data-v-a4fbc47a] {\n  font-size: 2em;\n}\n", ""]);

